import { apiClient } from './api'

// ── Types ──────────────────────────────────────────────────

export interface NearestStructure {
  name: string
  code: string
  distanceKm: number
  bedsAvailable: number | null
  hasSpecialist: boolean
  hasStocks: boolean
  latitude: number
  longitude: number
  phone: string | null
}

export interface CapabilityStatus {
  name: string
  available: boolean
  label: string
}

export interface UrgenceResult {
  name: string
  code: string
  distanceKm: number
  verdict: 'RECOMMANDE' | 'PARTIEL' | 'SATURE'
  totalScore: number
  capabilities: CapabilityStatus[]
  latitude: number
  longitude: number
  phone: string | null
}

export interface UrgenceSearchRequest {
  motif: string
  latitude: number
  longitude: number
  limit?: number
}

// ── Motif definitions ──────────────────────────────────────

export interface MotifOption {
  id: string
  label: string
  icon: string
  color: string
  bgColor: string
}

export const URGENCE_MOTIFS: MotifOption[] = [
  { id: 'AVC / Paralysie', label: 'AVC / Paralysie', icon: '\u{1F9E0}', color: '#7c3aed', bgColor: '#ede9fe' },
  { id: 'Accident / Trauma', label: 'Accident / Trauma', icon: '\u{1F697}', color: '#ea580c', bgColor: '#fff7ed' },
  { id: 'Grossesse / Accouchement', label: 'Grossesse', icon: '\u{1F930}', color: '#ec4899', bgColor: '#fdf2f8' },
  { id: 'Douleur Poitrine', label: 'Douleur Poitrine', icon: '\u{2764}\u{FE0F}', color: '#dc2626', bgColor: '#fef2f2' },
  { id: 'Enfant malade', label: 'Enfant malade', icon: '\u{1F476}', color: '#2563eb', bgColor: '#eff6ff' },
  { id: 'Hemorragie', label: 'Hemorragie', icon: '\u{1FA78}', color: '#991b1b', bgColor: '#fef2f2' },
  { id: 'Brulure grave', label: 'Brulure grave', icon: '\u{1F525}', color: '#c2410c', bgColor: '#fff7ed' },
  { id: 'Autre urgence', label: 'Autre urgence', icon: '\u{2795}', color: '#6b7280', bgColor: '#f3f4f6' },
]

// ── API Calls ──────────────────────────────────────────────

export const urgenceApi = {
  findNearest: async (lat: number, lon: number, limit = 3): Promise<NearestStructure[]> => {
    const res = await apiClient.get<NearestStructure[]>(
      '/api/v1/public/structures/nearest',
      { params: { lat, lon, limit } }
    )
    return res.data
  },

  search: async (request: UrgenceSearchRequest): Promise<UrgenceResult[]> => {
    const res = await apiClient.post<UrgenceResult[]>(
      '/api/v1/public/structures/urgence/search',
      request
    )
    return res.data
  },
}
